import { useState, useEffect } from 'react';
import { rolePermissionsAPI } from '../services/api';

let cachedPermissions = null;
let cacheTimestamp = 0;
const CACHE_TTL = 60000; // 1 minute cache

export function usePermissions() {
  const [permissions, setPermissions] = useState(cachedPermissions);
  const [loading, setLoading] = useState(!cachedPermissions);
  const user = JSON.parse(localStorage.getItem('prismoline_user') || '{}');

  useEffect(() => {
    const now = Date.now();
    if (cachedPermissions && (now - cacheTimestamp) < CACHE_TTL) {
      setPermissions(cachedPermissions);
      setLoading(false);
      return;
    }

    rolePermissionsAPI.get().then(data => {
      cachedPermissions = data.permissions || {};
      cacheTimestamp = Date.now();
      setPermissions(cachedPermissions);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, []);

  const hasPermission = (permKey) => {
    if (user.role === 'Admin') return true;
    if (!permissions) return false;
    const allowed = permissions[permKey] || [];
    return allowed.includes(user.role);
  };

  return { hasPermission, loading, permissions };
}

// Invalidate cache when permissions are updated
export function invalidatePermissionsCache() {
  cachedPermissions = null;
  cacheTimestamp = 0;
}
